import constant from '@/constant.js'
import util from '@/util.js'

export default {
  getPromotions: function (cb) {
    util.apiHandler('post', `${constant.API_ROOT}/goodsActivity/getIsOn`, null, cb)
  },
  getPromotion: function (id, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/goodsActivity/findbyid/${id}`, null, cb)
  }
}
